import { COMPANY, SERVICE_AREAS, TESTIMONIALS } from "../data/site";

const SITE_URL = "https://hazinsulation.com";
const LOGO_URL = `${SITE_URL}/logo192.png`;

const SAME_AS = [
    "https://www.google.com/search?q=HAZ+Insulation+Chicago",
];

const ADDRESS = {
    "@type": "PostalAddress",
    addressLocality: "Tinley Park",
    addressRegion: "IL",
    postalCode: "60477",
    addressCountry: "US",
};

const GEO = {
    "@type": "GeoCoordinates",
    latitude: 41.5731,
    longitude: -87.7845,
};

const OPENING_HOURS = [
    {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ],
        opens: "07:30",
        closes: "18:00",
    },
];

const AREA_SERVED = SERVICE_AREAS.map((a) => ({
    "@type": "City",
    name: a.city,
    address: {
        "@type": "PostalAddress",
        addressLocality: a.city,
        addressRegion: a.state,
        postalCode: a.zip,
        addressCountry: "US",
    },
}));

function aggregateRating() {
    const ratings = TESTIMONIALS.map((t) => t.rating || 5);
    const total = ratings.reduce((s, n) => s + n, 0);
    const avg = total / ratings.length;
    return {
        "@type": "AggregateRating",
        ratingValue: avg.toFixed(1),
        reviewCount: Math.max(TESTIMONIALS.length, COMPANY.fiveStarReviews || 0),
        bestRating: "5",
        worstRating: "1",
    };
}

export function localBusinessJsonLd({ url, withRating = false } = {}) {
    const node = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "@id": `${SITE_URL}/#business`,
        name: COMPANY.name,
        legalName: COMPANY.legal,
        url: url || SITE_URL,
        logo: LOGO_URL,
        image: LOGO_URL,
        telephone: COMPANY.phone,
        email: COMPANY.email,
        priceRange: "$$",
        address: ADDRESS,
        geo: GEO,
        openingHoursSpecification: OPENING_HOURS,
        areaServed: AREA_SERVED,
        sameAs: SAME_AS,
    };
    if (withRating) node.aggregateRating = aggregateRating();
    return node;
}

export function serviceJsonLd({ name, description, url, areaName }) {
    return {
        "@context": "https://schema.org",
        "@type": "Service",
        name,
        description,
        url,
        provider: { "@id": `${SITE_URL}/#business` },
        serviceType: name,
        areaServed: areaName
            ? { "@type": "Place", name: areaName }
            : AREA_SERVED,
        aggregateRating: aggregateRating(),
    };
}

export function reviewListJsonLd(testimonials = TESTIMONIALS) {
    return testimonials.map((t) => ({
        "@context": "https://schema.org",
        "@type": "Review",
        itemReviewed: { "@id": `${SITE_URL}/#business` },
        author: { "@type": "Person", name: t.name },
        reviewRating: {
            "@type": "Rating",
            ratingValue: t.rating || 5,
            bestRating: "5",
            worstRating: "1",
        },
        reviewBody: t.text,
    }));
}

export function breadcrumbJsonLd(items) {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((it, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: it.name,
            item: it.url.startsWith("http") ? it.url : `${SITE_URL}${it.url}`,
        })),
    };
}

export function aggregateRatingJsonLd() {
    return {
        "@context": "https://schema.org",
        ...aggregateRating(),
        itemReviewed: { "@id": `${SITE_URL}/#business` },
    };
}

export const SITE_BASE_URL = SITE_URL;
